/**
 * テーブルにSimpleBarを適用する
 *
 * [問題]wp-block-flexible-table-block-tableに直接simplebarを適用すると、
 * 管理画面で設定したテーブルのスタイルがつかなくなる
 *
 * [解決]wp-block-flexible-table-block-tableを囲うwrapperを生成し、
 * そのwrapperにSimpleBarを適用してテーブルのスクロールを可能にした
 */
import SimpleBar from "simplebar";

export const simpleBarOnTables = () => {
  const tableBlocks = document.querySelectorAll(".js-single-news-content .wp-block-flexible-table-block-table");

  tableBlocks.forEach((tableBlock) => {
    // wp-block-flexible-table-block-tableをwrapperで囲む
    const wrapper = document.createElement("div");
    wrapper.className = "table-wrapper";

    tableBlock.parentNode.insertBefore(wrapper, tableBlock);
    wrapper.appendChild(tableBlock);

    // wrapperにSimpleBarを適用
    const simpleBar = new SimpleBar(wrapper, {
      autoHide: false,
    });
  });
};
